(() => {
  'use strict';

  const root = document.querySelector('[data-cos-maintenance]');
  if (!root || document.body?.dataset.designMode === 'true') return;

  const endpoint = root.dataset.endpoint;
  const tenant = root.dataset.tenant || 'nerdyvana';
  if (!endpoint) return;

  const applies = (windowState) => {
    if (!windowState) return false;
    if (windowState.level === 'full') return true;
    if (windowState.level !== 'module') return false;
    const scopes = Array.isArray(windowState.affected_paths) ? windowState.affected_paths : [];
    return scopes.includes('shopify:*') || scopes.includes(`shopify:${tenant}`);
  };

  const formatTime = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat('de-DE', {
      dateStyle: 'medium',
      timeStyle: 'short',
      timeZone: 'Europe/Berlin'
    }).format(date);
  };

  const showOverlay = (windowState) => {
    const overlay = root.querySelector('[data-cos-maintenance-overlay]');
    const title = root.querySelector('[data-cos-maintenance-title]');
    const message = root.querySelector('[data-cos-maintenance-message]');
    const time = root.querySelector('[data-cos-maintenance-time]');
    if (!overlay || !title || !message || !time) return;

    title.textContent = windowState.title || 'Planmäßige Wartung';
    message.textContent = windowState.customer_message || 'Wir aktualisieren den Shop. Die Arbeiten werden so kurz wie möglich gehalten.';
    const end = formatTime(windowState.ends_at);
    time.textContent = end ? `Voraussichtliches Ende: ${end} Uhr` : 'Wir sind so schnell wie möglich wieder für dich da.';
    root.hidden = false;
    overlay.hidden = false;
    document.body.classList.add('cos-maintenance-active');
    overlay.focus?.();
  };

  const showBanner = (text) => {
    const banner = root.querySelector('[data-cos-maintenance-banner]');
    if (!banner) return;
    banner.textContent = text;
    root.hidden = false;
    banner.hidden = false;
  };

  const applyStatus = (payload) => {
    const status = payload?.maintenance;
    if (!status) return;
    const active = status.active;
    if (active && applies(active)) {
      showOverlay(active);
      return;
    }
    if (active?.level === 'degraded') {
      showBanner(`Eingeschränkter Betrieb: ${active.customer_message || 'Wartungsarbeiten laufen.'}`);
      return;
    }
    const next = status.next;
    if (!next || !applies(next)) return;
    const start = new Date(next.starts_at || '');
    if (Number.isNaN(start.getTime()) || start.getTime() - Date.now() > 24 * 60 * 60 * 1000) return;
    showBanner(`Geplante Wartung: ${formatTime(next.starts_at)} bis ${formatTime(next.ends_at)} Uhr`);
  };

  fetch(endpoint, {
    method: 'GET',
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
    cache: 'no-store'
  })
    .then((response) => {
      if (!response.ok) throw new Error(`maintenance status ${response.status}`);
      return response.json();
    })
    .then(applyStatus)
    .catch(() => {
      // Fail open: a status-feed problem must not make the Shopify storefront unavailable.
    });
})();
